import React from 'react';
import { LinkText, Typography, Tooltip } from '../ecosystem';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

const NoMedicalRecordTile = ({
    isMobile,
    technicalHelpDeskNumber,
    showToolTip,
    updateNoMedicalRecordToolTip
}) => {

    const noMedicalRecordTooltipText = "To fully experience the benefits and features of MyBSWHealth please call and connect your medical records";

    const noMedicalRecordrTooltipLinkText = "Okay, got it!";

    return (
        <Tooltip open={showToolTip}
            text={noMedicalRecordTooltipText}
            tooltipId="nomedicalrecord-tooltip"
            linkText={noMedicalRecordrTooltipLinkText}
            variant="spotlight"
            placement={isMobile ? "bottom" : "bottom"}
            linkOnClick={
                () => {
                    updateNoMedicalRecordToolTip();
                }
            }>
            <div className="no-medical-record-tile">
                <Typography
                    type={isMobile ? "cta-01" : "body-02"}
                    tag={isMobile ? "div" : "span"}
                    textAlign={isMobile ? "center" : ""}
                    color="$color-secondary-a2"
                >
                    Call us to link your medical record to access the full features of MyBSWHealth.
                </Typography>
                <LinkText
                    className="call-number"
                    href={"tel:" + technicalHelpDeskNumber}
                    typographyType="body-02"
                    display="inline-block"
                    onClick={
                        () => {
                            logUI("MBHWeb.UI.NoMedicalRecordTile.CallHelpDesk.Clicked", new Date(), Tools.getURLPath());
                        }
                    }
                >
                    CALL {technicalHelpDeskNumber}
                </LinkText>
            </div>
        </Tooltip>
    );
}

export default NoMedicalRecordTile;